export const WIDTH_MULTIPLIER = 1;
export const HEIGHT_MULTIPLIER = 1;
